import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ErrorInterface } from '../error/error.interface';
import { LabelInterface } from '../label/label.interface';

@Component({
  selector: 'app-number-input',
  templateUrl: './number-input.component.html',
  styleUrls: ['./number-input.component.scss'],
})
export class NumberInputComponent {
  @Input()
  public decrementDisabled = false;

  @Input()
  public incrementDisabled = false;

  @Input()
  public className: string;

  @Input()
  public error: ErrorInterface;

  @Input()
  public id: string;

  @Input()
  public label: LabelInterface;

  @Input()
  public max = 10;

  @Input()
  public min = 1;

  @Input()
  public name: string;

  @Input()
  public set value(val: number) {
    this.val = val;
    this.valueChange.emit(this.val);
  }

  public get value(): number {
    return this.val;
  }

  @Output()
  public valueChange = new EventEmitter<number>();

  private val: number = this.min;

  public decrement() {
    this.value = --this.val;
  }

  public increment() {
    this.value = ++this.val;
  }

  public get hasReachedUpperBound(): boolean {
    return this.val >= this.max;
  }

  public get hasReachedLowerBound(): boolean {
    return this.val <= this.min;
  }
}
